/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type WebCallFunnelStep =
  (typeof WebCallFunnelStep)[keyof typeof WebCallFunnelStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebCallFunnelStep = {
  FORM_SUBMITTED: 'FORM_SUBMITTED',
  ID_VERIFICATION_STARTED: 'ID_VERIFICATION_STARTED',
  ID_VERIFICATION_COMPLETED: 'ID_VERIFICATION_COMPLETED',
  PRECALL_VIEWED: 'PRECALL_VIEWED',
  MIC_PERMISSION_GRANTED: 'MIC_PERMISSION_GRANTED',
  MIC_PERMISSION_DENIED: 'MIC_PERMISSION_DENIED',
  CAM_PERMISSION_GRANTED: 'CAM_PERMISSION_GRANTED',
  CAM_PERMISSION_DENIED: 'CAM_PERMISSION_DENIED',
  DEVICES_READY: 'DEVICES_READY',
  AUDIO_DETECTED: 'AUDIO_DETECTED',
  SCREEN_SHARE_GRANTED: 'SCREEN_SHARE_GRANTED',
  INTERVIEW_STARTED: 'INTERVIEW_STARTED',
  JOIN_BLOCKED: 'JOIN_BLOCKED',
} as const;
